import 'jquery';
import '../utils/magnific-popup.js';

jQuery(document).ready(function ($) {
  const el = document.querySelector('#annual-toggle');

  const pricingCards = document.querySelector('.pricing-cards_modal');
  if (el) {
    el.onclick = function () {
      el.classList.toggle('active');
      pricingCards.classList.toggle('annual');
    };
  }

  setTimeout(() => {
    load_modal_form();
  }, 1000);
  load_modal_form();
  function load_modal_form() {
    jQuery('.modal-contact-us .open-popup-link').magnificPopup({
      type: 'inline',
      midClick: true,
      mainClass: 'mfp-fade'
    });
  }
});
